/**
 * Rynor Locale Modal
 *
 * Opens from the header COUNTRY button.
 * Uses Shopify's built-in localization form.
 * Updates the subheading country name + flag + free-shipping copy when the country changes.
 * v38: the free-shipping sentence comes from the language files (data-template on the span,
 * written by snippets/ryan-locale-modal.liquid) and the amount follows the selected country:
 * the shopper's own country is shown in their currency (assets/rynor-i18n.js), any other
 * country they pick is shown in the store currency until they confirm.
 */
(function () {
  // Prevent duplicate init
  if (window.__RYNOR_LOCALE_MODAL_INIT__) return;
  window.__RYNOR_LOCALE_MODAL_INIT__ = true;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  var modal = document.getElementById('ry-locale-modal');
  if (!modal) return;

  var overlay = qs('.ry-locale-modal__overlay', modal);
  var closeEls = qsa('[data-ry-locale-close]', modal);
  var countrySelect = qs('[data-ry-locale-country]', modal);
  var countryNameEl = qs('[data-ry-locale-country-name]', modal);
  var flagEl = qs('[data-ry-locale-flag]', modal);
  var shippingEl = qs('[data-ry-shipping-copy]', modal);

  function isoToFlagEmoji(iso) {
    if (!iso) return '';
    var code = String(iso).trim().toUpperCase();
    if (code.length !== 2) return code;

    var A = 65;
    var Z = 90;
    var OFFSET = 127397;
    var first = code.charCodeAt(0);
    var second = code.charCodeAt(1);

    if (first < A || first > Z || second < A || second > Z) return code;

    try {
      return (
        String.fromCodePoint(OFFSET + first) +
        String.fromCodePoint(OFFSET + second)
      );
    } catch (e) {
      return code;
    }
  }

  function getHeaderHeightPx() {
    var header = document.querySelector('header.section-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    // distance from viewport top to bottom of header, includes any top bar pushing header down
    return Math.max(0, rect.top + rect.height);
  }

  function setHeaderHeightVar() {
    try {
      document.documentElement.style.setProperty(
        '--ry-header-height',
        getHeaderHeightPx() + 'px'
      );
    } catch (e) {}
  }

  function updateFromCountry() {
    if (!countrySelect) return;

    var opt = countrySelect.options[countrySelect.selectedIndex];
    if (!opt) return;

    var iso = String(opt.value || '').toUpperCase();

    // Prefer explicit country name from Liquid
    var name = opt.getAttribute('data-country-name') || '';
    if (!name) {
      // fallback: parse option text up to the first slash
      var t = opt.textContent || '';
      name = (t.split('/')[0] || '').trim();
    }

    if (countryNameEl) countryNameEl.textContent = String(name).toUpperCase().trim();
    if (flagEl) flagEl.textContent = isoToFlagEmoji(iso) || iso;

    if (shippingEl) {
      var template = shippingEl.getAttribute('data-template') || '';
      var usCents = parseInt(shippingEl.getAttribute('data-us-cents'), 10) || 7500;
      var intlCents = parseInt(shippingEl.getAttribute('data-intl-cents'), 10) || 15000;
      var cents = iso === 'US' ? usCents : intlCents;
      var current = String(shippingEl.getAttribute('data-current-country') || '').toUpperCase();
      var amount = '';
      var I18n = window.RynorI18n;

      if (I18n) {
        amount = iso === current ? I18n.formatThreshold(cents) : I18n.formatShopWhole(cents);
      } else {
        amount = '$' + Math.round(cents / 100);
      }

      if (template) {
        shippingEl.innerHTML = template.replace('[[amount]]', amount);
      }
    }
  }

  function isOpen() {
    return modal.classList.contains('is-open');
  }

  function open() {
    if (isOpen()) return;
    setHeaderHeightVar();
    modal.classList.add('is-open');
    document.body.classList.add('ry-locale-modal-open');
    updateFromCountry();
  }

  function close() {
    if (!isOpen()) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('ry-locale-modal-open');
  }

  // Public API (used by header inline onclick fallback)
  try {
    window.RynorLocaleModal = window.RynorLocaleModal || {};
    window.RynorLocaleModal.open = open;
    window.RynorLocaleModal.close = close;
  } catch (e) {}

  // Open triggers: COUNTRY button + any [data-ry-locale-open]
  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest(
        '#country-selector-trigger, [data-ry-locale-open], .header__country-selector-button'
      );
      if (!trigger) return;
      if (modal.contains(trigger)) return; // ignore clicks within the modal

      e.preventDefault();
      e.stopPropagation();
      open();
    },
    true
  );

  // Close triggers
  closeEls.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (countrySelect) {
    countrySelect.addEventListener('change', updateFromCountry);
  }

  // Initial: replace ISO fallback with emoji, and correct shipping copy
  updateFromCountry();
})();
